import { useCallback, useState } from 'react';

import { CustomEventNames, logNavigationClick } from 'state/amplitude';

import { StoreLocatorViews } from '../types';

export const AMPLITUDE_VIEW_EVENT_MAP = {
  [StoreLocatorViews.LIST_VIEW]: 'Selected list view',
  [StoreLocatorViews.MAP_VIEW]: 'Selected map view',
};

export default function useStoreLocatorView() {
  const [currentView, setCurrentView] = useState(StoreLocatorViews.LIST_VIEW);

  const updateCurrentView = useCallback((newView: StoreLocatorViews) => {
    // log view switch event
    logNavigationClick(CustomEventNames.BUTTON_CLICK_STORE_LOCATOR_VIEW, {
      'Selected View': AMPLITUDE_VIEW_EVENT_MAP[newView],
    });
    // switch view state
    setCurrentView(newView);
  }, []);

  return {
    currentView,
    currentViewIsList: currentView === StoreLocatorViews.LIST_VIEW,
    currentViewIsMap: currentView === StoreLocatorViews.MAP_VIEW,
    updateStoreLocatorView: updateCurrentView,
  };
}
